import script from "./SlideItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideItem.vue?vue&type=script&setup=true&lang=ts"

import "./SlideItem.vue?vue&type=style&index=0&id=6f3bb228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3bb228"]])

export default __exports__